import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

type Props = ComponentProps<"div">;

export const Skeleton: FC<Props> = ({ className, ...props }) => (
  <div
    data-slot="skeleton"
    className={cn("bg-accent animate-pulse rounded-md", className)}
    {...props}
  />
);
